import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LimitPipeModule } from '@shared/core/pipes/limit';
import { TileForLoyaltyProgramProductCounterModule } from '@shared/core/components/tiles/tilesTypes/forLoyaltyProgramProductCounter';
import { SliderSimpleModule } from '@shared/core/components/slider/sliderTypes/simple';

import { ListForLoyaltyProgramProductsCounterComponent } from './list-for-loyalty-program-products-counter.shared.component';
import { TileForLoyaltyPointsCounterModule } from '@shared/core/components/tiles/tilesTypes/forLoyaltyPointsCounter';
@NgModule({
    declarations: [
        ListForLoyaltyProgramProductsCounterComponent
    ],
    imports: [
        CommonModule,
        LimitPipeModule,
        TileForLoyaltyProgramProductCounterModule,
        TileForLoyaltyPointsCounterModule,
        SliderSimpleModule,
    ],
    exports: [
        ListForLoyaltyProgramProductsCounterComponent
    ],
})
export class ListForLoyaltyProgramProductsCounterModule { }
